import PropTypes from 'prop-types';

import { ROUTES } from '#/config/routes';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';

function isDashLabel(label) {
  return !label || label === '—' || label === '-';
}

/**
 * 工單詳細資料 BOM 文字：有 bomId 時雙擊開 BOM 詳情頁（新分頁）。
 */
const WorkOrderBomLinkText = ({ label, bomId, className }) => {
  const display = isDashLabel(label) ? (label || '—') : label;
  const canNavigate = Boolean(bomId) && !isDashLabel(display);

  return (
    <TruncatedTextWithTooltip
      text={display}
      truncate={false}
      className={className}
      onNavigate={canNavigate ? () => {
        window.open(ROUTES.bomDetail(bomId), '_blank', 'noopener,noreferrer');
      } : null}
      tooltipContent={canNavigate ? '雙擊開啟 BOM（新分頁）' : null}
    />
  );
};

WorkOrderBomLinkText.propTypes = {
  label: PropTypes.string,
  bomId: PropTypes.string,
  className: PropTypes.string,
};

export default WorkOrderBomLinkText;
